 
 import React,{useState,useEffect} from "react";
 import { Formik } from "formik";
 import webRootContext from "../components/webrootcontext/WebRootContext";
 import Ribbon from "../framework/Ribbon";
 import FileUpload from "../framework/FileUpload";
 import InsurancePdf from "../assets/documents/InsuranceGuidelines.pdf";
 import Button from "../framework/Button";
 
 
 
 function UploadHealthInsurance(props){
   	const [responseError, setResponseError] = useState("");
   	const [formSubmitted, setFormSubmitted] = useState();
   	const [saveSuccess, setSaveSuccess] = useState();
   	const [fileUploaded, setFileUploaded] = useState(false);
   	const [submitEnabled,  setSubmitEnabled] = useState(true);
   	const [uploadInsuranceCompleted, setUploadInsuranceCompleted] = useState(false);
   	const [applicationAccepted, setApplicationAccepted] = useState();
   	const [applicationCompleted,  setApplicationCompleted] = useState(false);
   	const [applicationId, setApplicationId] = useState();
   	
 
    const getApplicantIdUrl =  webRootContext + "/rest/dashboard/getApplicantId";
    const healthProofUploadUrl = webRootContext + "/rest/documents/saveHealthDocument";	
    const fileUploadApi =  webRootContext + "/rest/fileUploadService/fileUpload/";
    const verifyDocApi = webRootContext + "/rest/documents/verifyHealthDocument";	
    const getDashboardStatusUrl =  webRootContext + "/rest/dashboard/getStatus";
    const dashboardUrl = webRootContext + '/ApplicantDashboard';
    const fileId = "healthinsurance";

    const fileErrorMessage =  'Proof of health insurance is required';
	const invalidFileLength = "The file name must be under 60 characters. Delete the file and upload a new one.";
    const errApi = "Error saving health insurance document.";
	
	const alreadySubmittedContent = 
	<div>
		<div className="padding-bottom-30">This task has already been submitted.</div>
			<Button
		       text={"RETURN TO DASHBOARD"}
		       styleName={"button button--primary"}
		       id={"button_submit"}
		       type="submit"
			   onClick={(e) => {returnToDashboard();}}
		       />
	</div>;
	
	const saveSuccessContent = 
	<div>
		<div className="padding-bottom-30">Thank you for submitting proof of insurance.</div>
		<div><Button text={"RETURN TO DASHBOARD"} styleName={"button button--primary"} id={"returnForm"} onClick={(e) => {returnToDashboard();}} /></div>
	</div>;
	
	
	const notApplicableContent = 
	<div>
		<div className="padding-bottom-30">Please return to the dashboard to view the status of your application and how to proceed.</div>
			<Button
		       text={"RETURN TO DASHBOARD"}
		       styleName={"button button--primary"}
		       id={"button_submit2"}
		       type="submit"
			   onClick={(e) => {returnToDashboard();}}
		       />
	</div>;
	
	//TODO: show upload result
	
	 
	 const checkKeyDown = (e) => {
		if (e.key === 'Enter') e.preventDefault();
	}
	 
	 useEffect(() => {
		 fetch(getApplicantIdUrl, {
						    method: 'GET', 
					   		headers: {
								'Accept': 'application/json',
								'Content-Type': 'application/json'
									},
							mode: "cors"})
						.then((response) => {
							return response.json();					
						})
						.then((data) => {		
							setApplicationId(data.applicantId);
							setApplicationCompleted(data.isApplicationCompleted);
							
							
							if(data.applicantId < 0 || (data.applicantId > 0 && data.isApplicationCompleted) ) {
								setApplicationAccepted(false);
							}else{
								verifyDoc(data.applicantId);
							}
													
						},(error) => {
							console.log("get application ID error: ",  error);
						});	
						
				function verifyDoc(id){
			  		fetch(verifyDocApi , {
				      	method: 'POST', 
				   		headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/json'
								},
				    	mode:"cors"})
			 		 .then((response) => {		
						  return response.json();
					  })
					  .then((data) => {
						   if(data === 0){		//already exists 
							   setUploadInsuranceCompleted(true);
							   setSubmitEnabled(false); 
					      }	else {
							  getDashboardStatusData(id);
						  }
					      
					      
					  }) 	  
			 		 .catch((err) => {
			          	console.log("error: ", err); 
			          	setResponseError(errApi);
				  		}	
			    	  );
		  		}
		  		
		  		
		  		function getDashboardStatusData(applicantId){
			
					if (applicantId === undefined || applicantId < 0 ){   //initial application not submitted
					   setApplicationAccepted(false);
						return;
					}else {
						const url =  getDashboardStatusUrl + "?applicantId="+applicantId ;
				   	   
			           fetch(url, {
						    method: 'GET', 
					   		headers: {
								'Accept': 'application/json',
								'Content-Type': 'application/json'
									},
							mode: "cors"})
							.then((response) => {	
								return response.json();					
							})
							.then((data) => {									
							    setApplicationAccepted(data.applicantId > 0 && data.isAccepted);
							    
							    //console.log("application status:", data)	;	   
							},(error) => {
								console.log("dashboard error: ",  error);
							});					
					}
									 
		   	    } 
						
	},[getApplicantIdUrl, applicationId, verifyDocApi, getDashboardStatusUrl, applicationCompleted]);	

	 
	 
	 function returnToDashboard() {
      window.location.href = dashboardUrl;
  } 
	 
	 function saveHealthInsuranceDocument(applicationId){
        
		
	 		fetch(healthProofUploadUrl, {
	      	method: 'POST', 
	   		headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
					},
			body: applicationId, // JSON.stringify(data),
	    		mode:"cors"})
 		 .then((response) => {
			 
			  if(response.ok){			       
					setSaveSuccess(true);
			   }
			   else{		   
					setResponseError(errApi);
					setSaveSuccess(false);
		    		
			   }
			   			    
		 })
		  
 		 .catch((err) => {
          	console.log("error", err); 
          	setResponseError(errApi);
	  		}	
    	  );
   }
	 
  return(
	 <div>
	 	<div className={ uploadInsuranceCompleted ? 'show_div' : 'hide_div'}>
	 		<div id="alreadySubmittedDiv" className="div_1_col">
				<Ribbon label="SUBMITTED" status={"checkmark"} subheader={""} content={alreadySubmittedContent} />
			</div>
	 	</div>
	 	
	 	<div id="saveSuccess" className={(saveSuccess ? 'show_div' : 'hide_div')}>
			<div id="saveSuccessDiv" className="div_1_col">
				<Ribbon label="SUBMITTED" status={"checkmark"} subheader={""} content={saveSuccessContent} />
			</div>
		</div>
	 	
	 	<div id="noAcceptedApplication" className={ !applicationCompleted && (applicationAccepted || applicationAccepted === undefined) ? 'hide_div':'show_div' }>
         	<div id="notApplicableDiv" className="div_1_col">
				<Ribbon label="RETURN TO DASHBOARD" status={"error"} subheader={""} content={notApplicableContent} />
			</div>
         </div>
         
	    <div className={ applicationCompleted || uploadInsuranceCompleted || !applicationAccepted || saveSuccess ? 'hide_div' : 'show_div'}>
		    <Formik 
		        enablereinitialize={true}
		    	initialValues={{
		        	"healthInsuranceUploaded": fileUploaded
		      	}}
		      	validate={values => {
		         		const errors = {};
		         		
		         		//TODO:  other error message
		         	    if (fileUploaded !== true ) {                   		
						    errors.healthInsuranceUploaded = fileErrorMessage;
					    }
			       	 if( Object.keys(errors).length > 0) {              			
							 setResponseError("REVIEW ISSUES BELOW");
						  } else {
					          setResponseError("");
					      }	
					      
					      return errors;
					      
		         		}}
		 		onSubmit={(values, { setSubmitting}) => {
		                    setTimeout(() => {
		                        saveHealthInsuranceDocument(applicationId);
		                        setSubmitting(false);
				     	            	
		                        }, 100);
				        
		                }}
		     > 	
		      	{({
		          values /* all data need to run the valdation*/,
		            errors /* all error strings */,
		            touched /* all field touch event  */,
		            handleChange /* value change event handler */,
		            handleBlur /* onBlur event handler */,
		            handleSubmit /* for submit button */,
		            isSubmitting /* for submit button */,
		            isValid /* for submit button */,
		            dirty /* for submit button */,
		            validateForm,
		            setFieldError
		        }) => (
		          <form onSubmit={handleSubmit}  onKeyDown={(e) => checkKeyDown(e)} noValidate>
		          		<div className="div_3_col">
					   	     <div className="breadcrumbLink"><a href="##" onClick={(e) => {returnToDashboard();}}>Dashboard</a></div>  
					   		 <div className="page_title padding-bottom-20">Proof of Health Insurance Coverage</div>  
					   		 
					   		 <div id="formikErrors" className={( responseError !== "" && formSubmitted ? 'show_div' : 'hide_div')}>
					               <div id="formikFailDiv">
					               		<Ribbon label={responseError} status={"error"} subheader={""} content={""} />
					               </div>
					          </div>
					                
					         <div>
					         	<div class="normal_txt padding-bottom-20">
					         		In compliance with both State and Federal mandates, Boston Children’s Hospital requires all non-employee visitors to purchase and maintain health insurance 
					         		for the entire duration of their observership at Boston Children’s Hospital. Please obtain a copy of your insurance policy from your insurance 
					         		provider in English and upload it at least 30 days prior to your start date. Review <a className="color--boston-ocean" href={InsurancePdf} target="_blank" rel="noopener noreferrer">insurance requirement guidelines</a> (pdf)
					         		
					         	</div>
					         	
					         	 <div>         		
					             		<FileUpload
										    id="healthInsuranceUploaded"
							                label={"Upload proof of insurance (.pdf, .jpg, .png, or .gif)"}
							                name="healthInsuranceUploaded"
							                isRequired={true}
							                numberOfFiles={1}
							                fileSize={"5MB"} // should it be 5MB according to use  case
							                fileType={["pdf","image_basic"]}			
							                maxFileNameLength={60} //Database column that stores the file name is limited to 100	
							                instructionMessage={""}
							                helpMessage={"File format: .pdf, .jpg, .png, .gif (limit 1 file under 5 MB)"}
							                hasError={touched.healthInsuranceUploaded && errors.healthInsuranceUploaded}
							                errorMessage={errors.healthInsuranceUploaded}
							                uploadApi={fileUploadApi + fileId} 
											onChange={(e) => {
											    // e is an array of loaded file item or error
											    let tmp = e && e.length > 0 && e[0]!== 'F' && e[0].filename.length < 60;
											    setFileUploaded(tmp? true : false);
											    touched.healthInsuranceUploaded = true;
												if(!tmp){
													if(e.length === 0){
														setFieldError("healthInsuranceUploaded",  fileErrorMessage);
													}
													else if (e[0].filename.length > 60){
														setFieldError("healthInsuranceUploaded", invalidFileLength );	//need to display field error when fileupload on change	
													}
													else{
														setFieldError("healthInsuranceUploaded", "Upload a .pdf, .jpg, .png, or .gif (limit 1 file under 5 MB)"); 
													}	//need to display field error when fileupload on change but submit button is not clicked								
												}else{
													setFieldError("healthInsuranceUploaded", null);											
												}	
											    
											}}
											onBlur={(e) => {
											}}
							              />
							           <hr className="hr--light" />
							        </div>
							        
							        <div>
							          <Button
							                text={"SUBMIT INSURANCE"}
							                styleName={"button button--primary"}
							                id={"button_submit"}
							                type="submit"
							                disabled={submitEnabled}
							                onClick={(e) =>{setFormSubmitted(true); validateForm();  }  }           
							               
							          />
					                </div>
					         </div>	
					   	</div>
		          
		          </form>
		          
		        )
		          
		        }
		     </Formik>
	   
	   </div>
   </div>
  )
  
 }
 
 export default UploadHealthInsurance;